import { CircularProgress, IconButton } from '@material-ui/core';
import { useState } from 'react';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton, StandardButtonProps } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface RefreshIconButtonProps extends Omit<StandardButtonProps, 'onClick' | 'size'> {
  buttonType?: 'icon' | 'button';
  onClick: () => Promise<void>;
}

export const RefreshIconButton = ({ onClick, buttonType = 'icon', ...props }: RefreshIconButtonProps) => {
  const { palette } = useCustomTheme();
  const { refreshing } = useCheckoutSessionContext();

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  const loading = refreshing || isLoading;

  if (buttonType === 'button') {
    return (
      <StandardButton loading={loading} onClick={handleClick} size="small" color="default" {...props}>
        <Text tId={'REFRESH'} />
      </StandardButton>
    );
  }

  return (
    <IconButton
      disabled={loading}
      onClick={handleClick}
      size="small"
      color="default"
      style={{ padding: 4, height: 32, width: 32, color: palette.text.secondary }}
      {...props}
    >
      {loading ? (
        <CircularProgress
          size={18}
          thickness={5}
          color={'inherit'}
          style={{ paddingBlock: '4px', color: palette.text.secondary }}
        />
      ) : (
        <Icon size={24} style={{ color: 'inherit' }}>
          refresh
        </Icon>
      )}
    </IconButton>
  );
};
